// https://github.com/VGW/pam-identity-app/blob/fdab5e8a71cca2ccb9a4b56d7a0a601d9e1181fb/app/pam-account-api/src/main/kotlin/co/vgw/pam/controls/application/models/BrandControlsConfigurations.kt
export enum FrontendExperience {
  /**
   * Simple Due Diligence is required for purchases
   */
  SDD_IN_STORE = 'SDD_IN_STORE',
  /**
   * Player must verify on login
   */
  MUST_VERIFY_NOW = 'MUST_VERIFY_NOW',

  SELF_EXCLUSION = 'SELF_EXCLUSION',
  TAKE_A_BREAK = 'TAKE_A_BREAK',
  CDD_REQUIRED = 'CDD_REQUIRED',
  PLAYER_UNDER_AGE = 'PLAYER_UNDER_AGE',
  RESTRICTED_JURISDICTION = 'RESTRICTED_JURISDICTION',
}
